import { css } from "@emotion/react";
import { theme } from "@product/scmp-sdk";
import { useSetAtom } from "jotai";
import type { FunctionComponent } from "react";

import { hamburgerMenuAtom } from "~/components/hamburger-menu/atoms";
import { PageType } from "~/lib/router/enums";
import { useCurrentPageType } from "~/lib/router/hooks";
import { page as kidsPage } from "~/pages/posties/kids";
import { page as parentsPage } from "~/pages/posties/parents";

import { DynamicHeaderAvatar } from "./dynamics";
import {
  ActionButton,
  Container,
  FeaturesWrapper,
  RedirectButtonContainer,
  StyledButton,
  StyledIconMenu,
} from "./styles";

export type Props = {
  className?: string;
};

export const HeaderActions: FunctionComponent<Props> = ({ className }) => {
  const setHamburgerMenuState = useSetAtom(hamburgerMenuAtom);

  const pageType = useCurrentPageType();

  const renderButton = () =>
    pageType === PageType.PostiesParents ? (
      <StyledButton {...kidsPage.route({})} variant="link">
        FOR KIDS
      </StyledButton>
    ) : (
      <StyledButton {...parentsPage.route({})} variant="link">
        FOR PARENTS
      </StyledButton>
    );

  return (
    <Container className={className}>
      <FeaturesWrapper>
        <ActionButton
          $responsiveVariants={{
            desktopUp: "show",
            largeDesktopUp: "show",
            mobileUp: "hidden",
            tabletUp: "show",
          }}
        >
          <RedirectButtonContainer>{renderButton()}</RedirectButtonContainer>
        </ActionButton>
        <ActionButton
          $responsiveVariants={{
            desktopUp: "show",
            largeDesktopUp: "show",
            mobileUp: "show",
            tabletUp: "show",
          }}
        >
          <DynamicHeaderAvatar />
        </ActionButton>
        <ActionButton
          $extraCss={css`
            ${theme.breakpoints.up("tablet")} {
              margin-inline-start: 8px;
            }
          `}
          $responsiveVariants={{
            desktopUp: "hidden",
            largeDesktopUp: "hidden",
            mobileUp: "show",
            tabletUp: "show",
          }}
          onClick={() => {
            setHamburgerMenuState(current => ({
              ...current,
              isOpen: !current.isOpen,
            }));
          }}
        >
          <StyledIconMenu />
        </ActionButton>
      </FeaturesWrapper>
    </Container>
  );
};

HeaderActions.displayName = "HeaderActions";
